// extracted by mini-css-extract-plugin
module.exports = {"box":"box_box__1DZnl","fail":"box_fail__2befj box_box__1DZnl","success":"box_success__YuwZr box_box__1DZnl"};